export default {
  // 车位查询页面
  'pages.search.parking.tab.all': '全部车位',
  'pages.search.parking.tab.favorite': '我的收藏',

  // 停车位管理页面
  'pages.parking.title': '停车位管理',
  'pages.parking.subTitle': '管理小区内的停车位信息',
  'pages.parking.breadcrumb.property': '物业管理',
  'pages.parking.breadcrumb.baseData': '基础数据',
  'pages.parking.breadcrumb.parking': '停车位管理',

  // 停车位列表
  'pages.parking.table.title': '停车位列表',
  'pages.parking.table.columns.building': '楼栋',
  'pages.parking.table.columns.location': '位置',
  'pages.parking.table.columns.area': '区域',
  'pages.parking.table.columns.parkingNumber': '车位编号',
  'pages.parking.table.columns.parkingType': '车位类型',
  'pages.parking.table.columns.parkingStatus': '车位状态',
  'pages.parking.table.columns.amount': '金额(元)',
  'pages.parking.table.columns.reserveAmount': '预定金额',
  'pages.parking.table.columns.bindHouse': '绑定房屋',
  'pages.parking.table.columns.ownerName': '业主姓名',
  'pages.parking.table.columns.ownerPhone': '业主电话',
  'pages.parking.table.columns.remarks': '备注',
  'pages.parking.table.columns.createdTime': '创建时间',
  'pages.parking.table.columns.operations': '操作',
  'pages.parking.table.tab.all': '全部',
  'pages.parking.table.tab.reserved': '已预订',

  // 车位状态
  'pages.parking.status.available': '可用',
  'pages.parking.status.sold': '已售',
  'pages.parking.status.rented': '已租',
  'pages.parking.status.reserved': '预留',
  'pages.parking.status.disabled': '停用',

  // 操作按钮
  'pages.parking.actions.view': '查看',
  'pages.parking.actions.sell': '销售',

  // 停车位详情弹窗
  'pages.parking.detail.title': '停车位详情',
  'pages.parking.detail.tab.detail': '车位详情',
  'pages.parking.detail.tab.basic': '基础信息',
  'pages.parking.detail.tab.sale': '车位出售',
  'pages.parking.detail.tab.rent': '车位出租',
  'pages.parking.detail.tab.repayment': '车位还款',
  'pages.parking.detail.tab.managementFee': '车位管理费',
  'pages.parking.detail.tab.document': '关联文档',
  'pages.parking.detail.tab.operationLog': '操作日志',
  'pages.parking.detail.basicInfo': '基本信息',

  // 车位关联文档
  'pages.parking.document.table.title': '关联文档',
  'pages.parking.document.table.columns.category': '文档分类',
  'pages.parking.document.table.columns.fileType': '文件类型',
  'pages.parking.document.table.columns.fileSize': '文件大小',
  'pages.parking.document.table.columns.createdBy': '创建人',
  'pages.parking.document.table.columns.createdTime': '创建时间',
  'pages.parking.document.table.columns.remarks': '备注',
  'pages.parking.document.table.columns.action': '操作',
  'pages.parking.document.action.add': '添加文档',
  'pages.parking.document.action.download': '下载',
  'pages.parking.document.action.chooseFile': '选择文件',
  'pages.parking.document.action.uploading': '上传中',
  'pages.parking.document.action.create': '添加',
  'pages.parking.document.action.update': '更新',
  'pages.parking.document.modal.createTitle': '添加文档',
  'pages.parking.document.modal.editTitle': '编辑文档',
  'pages.parking.document.form.category.label': '文档分类',
  'pages.parking.document.form.category.placeholder': '请选择文档分类',
  'pages.parking.document.form.category.required': '请选择文档分类',
  'pages.parking.document.form.file.label': '文档文件',
  'pages.parking.document.form.remarks.label': '备注',
  'pages.parking.document.form.remarks.placeholder': '请输入备注信息',
  'pages.parking.document.form.remarks.maxLength': '备注长度不能超过500个字符',
  'pages.parking.document.tip.uploaded': '✓ 已上传: {name}',
  'pages.parking.document.message.uploadSuccess': '文件上传成功',
  'pages.parking.document.message.uploadFailed': '文件上传失败',
  'pages.parking.document.message.createSuccess': '文档添加成功',
  'pages.parking.document.message.createFailed': '添加失败',
  'pages.parking.document.message.updateSuccess': '文档更新成功',
  'pages.parking.document.message.updateFailed': '更新失败',
  'pages.parking.document.message.deleteSuccess': '文档删除成功',
  'pages.parking.document.message.deleteFailed': '删除失败',
  'pages.parking.document.warning.noFilePath': '文件路径不存在',
  'pages.parking.document.error.noBizId': '车位ID不存在',
  'pages.parking.document.validation.fileRequired': '请先上传文件',
  'pages.parking.document.confirm.delete.title': '确认删除',
  'pages.parking.document.confirm.delete.content': '确定要删除文档"{name}"吗？',
  'pages.parking.detail.locationInfo': '位置信息',
  'pages.parking.detail.bindInfo': '绑定信息',
  'pages.parking.detail.bindAppInfo': '绑定APP账户',
  'pages.parking.detail.ownerInfo': '业主信息',
  'pages.parking.detail.saleInfo': '销售信息',
  'pages.parking.detail.rentalInfo': '租赁信息',
  'pages.parking.detail.priceInfo': '价格信息',
  'pages.parking.detail.systemInfo': '系统信息',

  // 车位操作日志
  'pages.parking.operationLog.title': '操作日志',
  'pages.parking.operationLog.action.refresh': '刷新',
  'pages.parking.operationLog.columns.createdTime': '操作时间',
  'pages.parking.operationLog.columns.logType': '操作类型',
  'pages.parking.operationLog.columns.message': '操作信息',
  'pages.parking.operationLog.columns.operatorName': '操作人',
  'pages.parking.operationLog.columns.operatorIp': '操作IP',

  // 详情字段标签
  'pages.parking.detail.label.parkingNumber': '车位编号',
  'pages.parking.detail.label.parkingType': '车位类型',
  'pages.parking.detail.label.parkingStatus': '车位状态',
  'pages.parking.detail.label.building': '楼栋',
  'pages.parking.detail.label.location': '位置',
  'pages.parking.detail.label.area': '区域',
  'pages.parking.detail.label.bindHouse': '绑定房屋',
  'pages.parking.detail.label.ownerInfo': '业主信息',
  'pages.parking.detail.label.ownerName': '业主姓名',
  'pages.parking.detail.label.ownerPhone': '业主电话',
  'pages.parking.detail.label.appUsername': 'APP用户名',
  'pages.parking.detail.label.appName': 'APP姓名',
  'pages.parking.detail.label.appPhone': 'APP手机号',
  'pages.parking.detail.label.appEmail': 'APP邮箱',
  'pages.parking.detail.label.saleAmount': '销售金额',
  'pages.parking.detail.label.discountAmount': '优惠金额',
  'pages.parking.detail.label.finalAmount': '最终金额',
  'pages.parking.detail.label.monthlyRepaymentLimit': '每月还款额度',
  'pages.parking.detail.label.saleTime': '销售时间',
  'pages.parking.detail.label.rent': '租金',
  'pages.parking.detail.label.rentStartTime': '开始时间',
  'pages.parking.detail.label.rentEndTime': '结束时间',
  'pages.parking.detail.label.rentPeriod': '租赁期限',
  'pages.parking.detail.label.parkingAmount': '车位金额',
  'pages.parking.detail.label.createdTime': '创建时间',
  'pages.parking.detail.label.updatedTime': '更新时间',
  'pages.parking.detail.label.remarks': '备注',

  // 按钮
  'pages.parking.detail.button.close': '关闭',

  // 业主绑定/解绑
  'pages.parking.owner.bind.button': '绑定业主',
  'pages.parking.owner.bind.success': '绑定业主成功',
  'pages.parking.owner.bind.failed': '绑定业主失败',
  'pages.parking.owner.unbind.button': '解除绑定',
  'pages.parking.owner.unbind.confirm.title': '确认解除绑定',
  'pages.parking.owner.unbind.confirm.content':
    '解除后将清空当前车位业主信息，是否继续？',
  'pages.parking.owner.unbind.success': '解除绑定成功',
  'pages.parking.owner.unbind.failed': '解除绑定失败',
  'pages.parking.owner.edit.button': '编辑业主信息',
  'pages.parking.owner.update.success': '业主信息更新成功',
  'pages.parking.owner.update.failed': '业主信息更新失败',
  'pages.parking.owner.form.ownerNamePlaceholder': '请输入业主姓名',
  'pages.parking.owner.form.ownerPhonePlaceholder': '请输入业主电话',
  'pages.parking.owner.select.placeholder': '请选择一个业主',
  'pages.parking.owner.select.current': '已选业主：',
  'pages.parking.owner.modal.title': '选择业主',
  'pages.parking.owner.modal.okText': '绑定',
  'pages.parking.owner.modal.cancelText': '取消',
  'pages.parking.owner.table.select': '选择',
  'pages.parking.owner.table.username': '用户名',
  'pages.parking.owner.table.name': '姓名',
  'pages.parking.owner.table.phone': '手机号',
  'pages.parking.owner.table.email': '邮箱',
  'pages.parking.owner.table.idCard': '身份证号',
  'pages.parking.owner.table.status': '状态',
  'pages.parking.owner.status.enabled': '正常',
  'pages.parking.owner.status.disabled': '禁用',

  // 收藏
  'pages.parking.favorite.button.favorite': '收藏',
  'pages.parking.favorite.button.favorited': '已收藏',
  'pages.parking.favorite.message.favoriteSuccess': '收藏成功',
  'pages.parking.favorite.message.favoriteFailed': '收藏失败',
  'pages.parking.favorite.message.unfavoriteSuccess': '已取消收藏',
  'pages.parking.favorite.message.unfavoriteFailed': '取消收藏失败',
  'pages.parking.favorite.message.actionFailed': '操作失败',

  // 停车位选择
  'pages.parking.select.current': '当前选择：',

  // 货币符号
  'pages.parking.currency.symbol': '₱',

  // 停车位层级结构树
  'pages.parking.structureTree.title': '停车位层级结构',
  'pages.parking.structureTree.action.addFloor': '添加楼层',
  'pages.parking.structureTree.confirm.deleteTitle': '确认删除',
  'pages.parking.structureTree.confirm.deleteContent':
    '确定要删除"{name}"吗？删除后其子节点也会被删除。',
  'pages.parking.structureTree.message.loadFailed': '加载停车位层级结构失败',
  'pages.parking.structureTree.message.deleteSuccess': '删除成功',
  'pages.parking.structureTree.message.deleteFailed': '删除失败',
  'pages.parking.structureTree.message.updateSuccess': '更新成功',
  'pages.parking.structureTree.message.updateFailed': '更新失败',
  'pages.parking.structureTree.message.createSuccess': '创建成功',
  'pages.parking.structureTree.message.createFailed': '创建失败',
  'pages.parking.structureTree.form.editTitle': '编辑停车位层级',
  'pages.parking.structureTree.form.createTitle': '添加停车位层级',
  'pages.parking.structureTree.form.label.name': '名称',
  'pages.parking.structureTree.form.label.sort': '排序',
  'pages.parking.structureTree.form.placeholder.name':
    '请输入名称，如：地下二层、A区',
  'pages.parking.structureTree.form.placeholder.sort': '请输入排序号',
  'pages.parking.structureTree.form.validation.nameRequired': '请输入名称',
  'pages.parking.structureTree.form.validation.nameMaxLength':
    '名称长度不能超过100个字符',

  // 停车位表单
  'pages.parking.form.editTitle': '编辑停车位',
  'pages.parking.form.createTitle': '新增停车位',
  'pages.parking.form.basicInfo': '基本信息',
  'pages.parking.form.locationInfo': '位置信息',
  'pages.parking.form.ownerInfo': '业主信息',
  'pages.parking.form.saleInfo': '销售信息',
  'pages.parking.form.rentalInfo': '租赁信息',
  'pages.parking.form.remarksInfo': '备注信息',
  'pages.parking.form.status.available': '空置',
  'pages.parking.form.status.rented': '已出租',
  'pages.parking.form.status.sold': '已出售',
  'pages.parking.form.status.reserved': '已预定',
  'pages.parking.form.status.unknown': '未知',

  // 表单字段标签
  'pages.parking.form.label.building': '所属楼栋',
  'pages.parking.form.label.location': '位置',
  'pages.parking.form.label.floor': '楼层',
  'pages.parking.form.label.area': '区域',
  'pages.parking.form.label.parkingNumber': '车位编号',
  'pages.parking.form.label.parkingType': '车位类型',
  'pages.parking.form.label.parkingStatus': '车位状态',
  'pages.parking.form.label.price': '车位价格',
  'pages.parking.form.label.ownerName': '业主姓名',
  'pages.parking.form.label.ownerPhone': '业主电话',
  'pages.parking.form.label.saleAmount': '销售金额',
  'pages.parking.form.label.discountAmount': '优惠金额',
  'pages.parking.form.label.finalAmount': '最终金额',
  'pages.parking.form.label.monthlyRepaymentLimit': '每月还款额度',
  'pages.parking.form.label.saleTime': '销售时间',
  'pages.parking.form.label.rent': '租金',
  'pages.parking.form.label.rentStartTime': '租赁开始时间',
  'pages.parking.form.label.rentEndTime': '租赁结束时间',
  'pages.parking.form.label.remarks': '备注',
  'pages.parking.form.label.bindHouse': '绑定房屋',
  'pages.parking.form.label.bindApp': '绑定APP账户',
  'pages.parking.form.label.owner': '业主',

  // 表单占位符
  'pages.parking.form.placeholder.building': '请选择楼栋',
  'pages.parking.form.placeholder.location': '请选择位置',
  'pages.parking.form.placeholder.houseId': '请选择房屋',
  'pages.parking.form.placeholder.floor': '请选择楼层',
  'pages.parking.form.placeholder.area': '请选择区域',
  'pages.parking.form.placeholder.parkingNumber': '请输入车位编号',
  'pages.parking.form.placeholder.parkingType': '请选择车位类型',
  'pages.parking.form.placeholder.parkingStatus': '请选择车位状态',
  'pages.parking.form.placeholder.price': '请输入车位价格',
  'pages.parking.form.placeholder.ownerName': '请输入业主姓名',
  'pages.parking.form.placeholder.ownerPhone': '请输入业主电话',
  'pages.parking.form.placeholder.bindApp': '请通过查询选择绑定APP用户',
  'pages.parking.form.placeholder.selectOwner': '请选择业主',
  'pages.parking.form.placeholder.bindHouse': '请选择关联房屋',
  'pages.parking.form.placeholder.saleAmount': '请输入销售金额',
  'pages.parking.form.placeholder.discountAmount': '请输入优惠金额',
  'pages.parking.form.placeholder.finalAmount': '自动计算',
  'pages.parking.form.placeholder.monthlyRepaymentLimit': '请输入每月还款额度',
  'pages.parking.form.placeholder.saleTime': '请选择销售时间',
  'pages.parking.form.placeholder.rent': '请输入租金',
  'pages.parking.form.placeholder.rentStartTime': '请选择租赁开始时间',
  'pages.parking.form.placeholder.rentEndTime': '请选择租赁结束时间',
  'pages.parking.form.placeholder.remarks': '请输入备注信息',

  // 表单验证消息
  'pages.parking.form.validation.buildingRequired': '请选择楼栋',
  'pages.parking.form.validation.locationRequired': '请选择位置',
  'pages.parking.form.validation.floorRequired': '请选择楼层',
  'pages.parking.form.validation.areaRequired': '请选择区域',
  'pages.parking.form.validation.parkingNumberRequired': '请输入车位编号',
  'pages.parking.form.validation.parkingNumberMaxLength':
    '车位编号长度不能超过50个字符',
  'pages.parking.form.validation.parkingTypeRequired': '请选择车位类型',
  'pages.parking.form.validation.parkingStatusRequired': '请选择车位状态',
  'pages.parking.form.validation.priceRequired': '请输入车位价格',
  'pages.parking.form.validation.priceMin': '车位价格不能为负数',
  'pages.parking.form.validation.saleAmountRequired': '请输入销售金额',
  'pages.parking.form.validation.saleAmountMin': '销售金额不能为负数',
  'pages.parking.form.validation.discountAmountMin': '优惠金额不能为负数',
  'pages.parking.form.validation.finalAmountRequired': '请输入最终金额',
  'pages.parking.form.validation.finalAmountMin': '最终金额不能为负数',
  'pages.parking.form.validation.monthlyRepaymentLimitMin':
    '每月还款额度不能为负数',
  'pages.parking.form.validation.saleTimeRequired': '请选择销售时间',
  'pages.parking.form.validation.rentRequired': '请输入租金',
  'pages.parking.form.validation.rentMin': '租金不能为负数',
  'pages.parking.form.validation.rentStartTimeRequired': '请选择租赁开始时间',
  'pages.parking.form.validation.rentEndTimeRequired': '请选择租赁结束时间',
  'pages.parking.form.validation.remarksMaxLength': '备注长度不能超过500个字符',

  // 表单按钮
  'pages.parking.form.button.ownerSearch': '查询',
  'pages.parking.form.button.ownerClear': '清除',
  'pages.parking.form.action.cancelSale': '取消出售',

  // 成功/失败消息
  'pages.parking.form.message.updateSuccess': '更新成功',
  'pages.parking.form.message.createSuccess': '创建成功',
  'pages.parking.form.message.updateFailed': '更新失败',
  'pages.parking.form.message.createFailed': '创建失败',
  'pages.parking.form.message.loadParkingTypeFailed':
    '获取车位类型字典失败，请联系管理员',
  'pages.parking.form.message.loadParkingTypeError':
    '加载车位类型字典失败，请联系管理员',
  'pages.parking.form.message.loadParkingStatusFailed':
    '获取车位状态字典失败，请联系管理员',
  'pages.parking.form.message.loadParkingStatusError':
    '加载车位状态字典失败，请联系管理员',

  // 房屋选择器
  'pages.parking.houseSelector.title': '选择房屋',
  'pages.parking.houseSelector.okText': '确认选择',
  'pages.parking.houseSelector.cancelText': '取消',

  // 房屋表格列
  'pages.parking.houseSelector.table.buildingName': '楼栋名称',
  'pages.parking.houseSelector.table.floor': '楼层',
  'pages.parking.houseSelector.table.houseNumber': '房屋编号',
  'pages.parking.houseSelector.table.ownerName': '业主姓名',
  'pages.parking.houseSelector.table.ownerPhone': '业主电话',
  'pages.parking.houseSelector.table.status': '状态',
  'pages.parking.houseSelector.table.operations': '操作',

  // 分隔符
  'pages.parking.form.divider.locationInfo': '位置信息',
  'pages.parking.form.divider.basicInfo': '基本信息',
  'pages.parking.form.divider.bindInfo': '绑定信息',
  'pages.parking.form.divider.saleInfo': '销售信息',
  'pages.parking.form.divider.rentalInfo': '租赁信息',
  'pages.parking.form.divider.remarksInfo': '备注信息',

  // Form field labels
  'pages.parking.form.label.houseId': '房屋ID',
  'pages.parking.form.label.selectOwner': '选择业主',

  // 车位表单 - 标签页
  'pages.parking.form.tab.basic': '基本信息',
  'pages.parking.form.tab.reserved': '车位预订',
  'pages.parking.form.tab.sold': '车位出售',
  'pages.parking.form.tab.rented': '车位出租',
  'pages.parking.form.tab.finance': '财务登记',
  'pages.parking.form.tab.repayment': '车位还款',
  'pages.parking.form.tab.document': '关联文档',
  'pages.parking.form.tab.operationLog': '操作日志',

  // 车位表单 - 操作按钮
  'pages.parking.form.button.cancelReservation': '取消预定',
  'pages.parking.form.button.cancelSale': '取消出售',
  'pages.parking.form.button.cancelRent': '取消出租',

  // 车位表单 - 预订信息
  'pages.parking.form.reserved.section.info': '预订信息',
  'pages.parking.form.reserved.section.agentInfo': '中介信息',
  'pages.parking.form.reserved.label.reserveUserName': '预定人姓名',
  'pages.parking.form.reserved.label.reserveUserPhone': '预定人手机号',
  'pages.parking.form.reserved.label.reserveUserEmail': '预订人邮箱',
  'pages.parking.form.reserved.label.reserveTime': '预定时间',
  'pages.parking.form.reserved.label.reserveAgentId': '车位中介',
  'pages.parking.form.reserved.label.agentCompany': '中介公司',
  'pages.parking.form.reserved.placeholder.reserveUserName': '请输入预定人姓名',
  'pages.parking.form.reserved.placeholder.reserveUserPhone':
    '请输入预定人手机号',
  'pages.parking.form.reserved.placeholder.reserveUserEmail':
    '请输入预订人邮箱',
  'pages.parking.form.reserved.placeholder.reserveTime': '请选择预定时间',
  'pages.parking.form.reserved.placeholder.reserveAgentId': '请选择车位中介',
  'pages.parking.form.reserved.validation.reserveUserNameMax':
    '预定人姓名不超过50个字符',
  'pages.parking.form.reserved.validation.reserveUserEmailPattern':
    '请输入正确的邮箱格式',

  // 车位表单 - 出售信息
  'pages.parking.form.sold.section.saleAmount': '销售金额',
  'pages.parking.form.sold.section.saleInfo': '销售信息',
  'pages.parking.form.sold.section.repaymentConfig': '还款配置',
  'pages.parking.form.sold.label.price': '销售价',
  'pages.parking.form.sold.label.area': '车位面积',
  'pages.parking.form.sold.label.areaPrefix': '面积',
  'pages.parking.form.sold.label.editArea': '编辑面积',
  'pages.parking.form.sold.label.discountAmount': '优惠金额',
  'pages.parking.form.sold.label.finalAmount': '成交价',
  'pages.parking.form.sold.label.soldType': '销售类型',
  'pages.parking.form.sold.label.mortgageTimeRange': '房贷还款时间',
  'pages.parking.form.sold.placeholder.price': '请输入销售价',
  'pages.parking.form.sold.placeholder.area': '请输入车位面积',
  'pages.parking.form.sold.placeholder.discountAmount': '请输入优惠金额',
  'pages.parking.form.sold.placeholder.finalAmount': '请输入成交价',
  'pages.parking.form.sold.placeholder.soldType': '请选择销售类型',
  'pages.parking.form.sold.placeholder.mortgageStartMonth': '开始月份',
  'pages.parking.form.sold.placeholder.mortgageEndMonth': '结束月份',
  'pages.parking.form.sold.option.soldType.loan': '贷款',
  'pages.parking.form.sold.option.soldType.fullPayment': '全款',
  'pages.parking.form.sold.validation.priceMin': '销售价不能为负数',
  'pages.parking.form.sold.validation.areaMin': '车位面积不能为负数',
  'pages.parking.form.sold.validation.discountAmountMin': '优惠金额不能为负数',
  'pages.parking.form.sold.validation.finalAmountMin': '成交价不能为负数',
  'pages.parking.form.sold.validation.soldTypeRequired': '请选择销售类型',

  // 车位表单 - 业主选择
  'pages.parking.form.owner.modal.title': '选择业主',
  'pages.parking.form.owner.table.idCard': '身份证号',
  'pages.parking.form.owner.status.enabled': '启用',
  'pages.parking.form.owner.status.disabled': '禁用',

  // 车位财务登记
  'pages.parking.finance.table.title': '财务登记记录',
  'pages.parking.finance.button.newRecord': '新建登记',
  'pages.parking.finance.loading': '加载中...',
  'pages.parking.finance.table.column.applyTime': '申请时间',
  'pages.parking.finance.table.column.feeType': '费用类型',
  'pages.parking.finance.table.column.amount': '金额',
  'pages.parking.finance.table.column.status': '状态',
  'pages.parking.finance.table.column.applicant': '申请人',
  'pages.parking.finance.table.column.remarks': '备注',
  'pages.parking.finance.status.pending': '申请中',
  'pages.parking.finance.status.approved': '已支付',
  'pages.parking.finance.status.rejected': '已取消',

  // Common action keys
  'common.action.create': '新建',
  'common.action.edit': '编辑',
  'common.action.delete': '删除',
  'common.action.confirm': '确定',
  'common.action.cancel': '取消',
  'common.action.deselect': '取消选择',
  'common.action.batchDelete': '批量删除',
  'common.label.selected': '已选择',
  'common.label.items': '项',
  'common.confirm.delete': '确定要删除这条记录吗？',
  'common.confirm.batchDelete': '确定要批量删除选中的记录吗？',

  // 车位财务登记弹窗
  'pages.parking.financeModal.title.create': '新建财务登记',
  'pages.parking.financeModal.label.parkingInfo': '车位信息',
  'pages.parking.financeModal.label.amountType': '金额类型',
  'pages.parking.financeModal.label.amount': '金额',
  'pages.parking.financeModal.label.bankStatement': '银行账单',
  'pages.parking.financeModal.label.remarks': '备注',
  'pages.parking.financeModal.placeholder.amountType': '请选择金额类型',
  'pages.parking.financeModal.placeholder.feeType': '请选择费用类型',
  'pages.parking.financeModal.placeholder.amount': '请输入金额',
  'pages.parking.financeModal.placeholder.bankStatement':
    '请输入关键词搜索银行账单',
  'pages.parking.financeModal.placeholder.remarks': '请输入备注信息',
  'pages.parking.financeModal.validation.amountTypeRequired': '请选择金额类型',
  'pages.parking.financeModal.validation.feeTypeRequired': '请选择费用类型',
  'pages.parking.financeModal.validation.amountRequired': '请输入金额',
  'pages.parking.financeModal.validation.bankStatementRequired':
    '请选择银行账单',
  'pages.parking.financeModal.amountType.income': '收入',
  'pages.parking.financeModal.amountType.expense': '支出',
  'pages.parking.financeModal.dictLabel.realEstateFeeType': '房产费用类型',
  'pages.parking.financeModal.message.parkingIdMissing': '车位ID不存在',
  'pages.parking.financeModal.message.createSuccess': '财务登记成功',
  'pages.parking.financeModal.message.createFailed': '财务登记失败',
  'pages.parking.financeModal.message.createFailedRetry':
    '财务登记失败，请稍后重试',
};
